import {
    AggregatorLiveMatchesNumber,
    AggregatorNextMatchesNumber,
    AggregatorOneOfTypeModel,
    AggregatorPopularMatchesNumber,
    ModelTypes,
} from '@om-fe/models';

export function getEventSliderTotalRecords(records: AggregatorOneOfTypeModel[]): number {
    const liveItem: AggregatorLiveMatchesNumber | undefined = records.find((obj: AggregatorLiveMatchesNumber) => obj._type === ModelTypes.LIVE_MATCHES_NUMBER) as AggregatorLiveMatchesNumber | undefined;
    const nextItem: AggregatorNextMatchesNumber | undefined = records.find((obj: AggregatorNextMatchesNumber) => obj._type === ModelTypes.NEXT_MATCHES_NUMBER) as AggregatorNextMatchesNumber | undefined;
    const popularItem: AggregatorPopularMatchesNumber | undefined = records.find((obj: AggregatorPopularMatchesNumber) => obj._type === ModelTypes.POPULAR_MATCHES_NUMBER) as AggregatorPopularMatchesNumber | undefined;

    if (liveItem) {
        return liveItem.numberOfLiveEvents;
    } else if (nextItem) {
        return nextItem.numberOfNextEvents;
    } else if (popularItem) {
        return popularItem.numberOfPopularEvents;
    } else {
        return 0;
    }
}

export function getLiveMatchListTotalRecords(records: AggregatorOneOfTypeModel[]): number {
    const item: AggregatorLiveMatchesNumber | undefined = records.find((obj: AggregatorLiveMatchesNumber) => obj._type === ModelTypes.LIVE_MATCHES_NUMBER) as AggregatorLiveMatchesNumber | undefined;

    if (!item) {
        // eslint-disable-next-line no-console
        console.error(new Error('Aggregator did not return the match number item'));

        return 0;
    }

    return item.numberOfLiveEvents;
}

export function getNextMatchListTotalRecords(records: AggregatorOneOfTypeModel[]): number {
    const item: AggregatorNextMatchesNumber | undefined = records.find((obj: AggregatorNextMatchesNumber) => obj._type === ModelTypes.NEXT_MATCHES_NUMBER) as AggregatorNextMatchesNumber | undefined;

    if (!item) {
        // eslint-disable-next-line no-console
        console.error(new Error('Aggregator did not return the match number item'));

        return 0;
    }

    return item.numberOfNextEvents;
}


export function getPopularMatchListTotalRecords(records: AggregatorOneOfTypeModel[]): number {
    const item: AggregatorPopularMatchesNumber | undefined = records.find((obj: AggregatorPopularMatchesNumber) => obj._type === ModelTypes.POPULAR_MATCHES_NUMBER) as AggregatorPopularMatchesNumber | undefined;

    if (!item) {
        // eslint-disable-next-line no-console
        console.error(new Error('Aggregator did not return the match number item'));

        return 0;
    }

    return item.numberOfPopularEvents;
}
